// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FeedbackModal-cls1___0740c9ef17e52f02af2{/*!*/}.FeedbackModal-cls2__fb7caf63fb89b36bd216{display:flex;align-items:center;grid-gap:4px;gap:4px;text-align:center;color:#535366}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FeedbackModal-cls1___0740c9ef17e52f02af2",
	"cls2": "FeedbackModal-cls2__fb7caf63fb89b36bd216 FeedbackModal-cls1___0740c9ef17e52f02af2"
};
export default ___CSS_LOADER_EXPORT___;
